import React, { useRef } from 'react';
import { Label } from '../../../../../../../common/labels/labelTypes';
import { useDispatch } from 'react-redux';
import { getColorDefaultHexValue } from '../../../../../../../common/colors/elementColorFormatUtil';
import ColorPopupContent from '../../colorTools/popup/ColorPopupContent';
import { COLOR_POPUP_MODE } from '../../colorTools/popup/colorPopupConstants';
import { LABEL_COLORS } from '../../../../../../../common/colors/colorConstants';
import { updateLabel } from '../../../../../../../common/labels/labelActions';
import CustomColorInput from '../../colorTools/CustomColorInput';

const LABEL_DEFAULT_COLORS = [...Object.values(LABEL_COLORS).filter((color) => color.name)];

const LabelColorPicker: React.FC<{ label: Label; openCustomColorPicker: () => void }> = ({
    label,
    openCustomColorPicker,
}) => {
    const customColorInputRef = useRef<CustomColorInput>(null);
    const dispatch = useDispatch();

    const setColor = (color: string | null) => {
        const colorToSave = color ? getColorDefaultHexValue(color) : undefined;

        dispatch(updateLabel(label._id, { color: colorToSave }));
    };

    return (
        <>
            <CustomColorInput
                className="absolute opacity-0 pointer-events-none"
                ref={customColorInputRef}
                initialColor={label.color}
                setColor={setColor}
            />
            <ColorPopupContent
                supportBackgroundColor={false}
                supportColorBar={false}
                supportDualColors={false}
                setColor={setColor}
                selectedColor={label.color}
                colorPopupMode={COLOR_POPUP_MODE.COLOR}
                defaultColors={LABEL_DEFAULT_COLORS}
                suggestedColors={[]}
                openCustomColorPicker={openCustomColorPicker}
            />
        </>
    );
};

export default LabelColorPicker;
